import * as React from 'react';
import { useEffect, useState } from 'react';
import activosApi from 'api/activos';
import lineasApi from 'api/lineas';
import familiasApi from 'api/familias';
import subfamiliasApi from 'api/subfamilias';
import marcasApi from 'api/marcas';
import modelosApi from 'api/modelos';
import hotelesApi from 'api/hoteles';
import departamentosApi from 'api/departamentos';
import estadosApi from 'api/estados';
import proveedoresApi from 'api/proveedores';
import arrendadorasApi from 'api/arrendadoras';
import tipoAdquisicionApi from 'api/tipoAdquisicion';
import depreciacionApi from 'api/depreciacion';
import { useNavigate, Navigate } from 'react-router-dom';
import { useToast, Input, Textarea } from '@chakra-ui/react';
import qrsApi from 'api/qrs';
import facturasApi from 'api/facturas';
// Chakra imports
import { Box, Button, Checkbox, CloseButton, Flex, SimpleGrid, Icon, Stack, Text, useColorModeValue, useTheme } from '@chakra-ui/react';

// Custom components
import Card from 'components/card/Card';
import InputField from 'components/fields/InputField';
import SelectField from 'components/fields/SelectField';
import PickList from 'components/fields/PickList';
import ToggleButton from 'components/fields/ToggleButton';
import CurrencyField from 'components/fields/CurrencyField';
import Dropzone from 'views/admin/main/ecommerce/newProduct/components/Dropzone';
import imagenes from 'api/imagenes';
import { isSoloLectura, getDepartamentosPermitidos } from 'utils/permissions';

// Assets
import { MdOutlineCloudUpload, MdArrowBack, MdOutlineInfo } from 'react-icons/md';
import { FiLoader } from 'react-icons/fi';

interface FormData {
  ActiveName: string;
  LineaId: string;
  FamiliaId: string;
  SubfamiliaId: string;
  MarcaId: string;
  ModeloId: string;
  SerialNumber: string;
  HotelId: string;
  DepartamentoId: string;
  EstadosId: string;
  ProveedorId: string;
  FacturaId: string;
  Precio: string;
  Precio_depreciado: string;
  Garantia: string; // Cambiar a número o mantener string según necesidad
  GarantiaMeses: string; // Nuevo campo para meses
  FechaGarantia: string; // Nuevo campo para fecha calculada
  PermitidoSalir: boolean;
  Status: string;
  UsuariosId: string;
  dropzone: string;
  imagenBase64: string;
  QRId?: string;
  Folio?: string;
  OtraMarca?: string;
  OtroModelo?: string;
  OtroProveedor?: string;
  Descripcion?: string; // 👈 nuevo
  SinGarantia?: boolean;
  TieneArrendamiento?: boolean;
  ArrendadoraId?: string;
  TipoAdquisicionId?: string;
  CategoriaDepreciacionId?: string;
  UbicacionExacta?: string;
  FechaAdquisicion?: string;
}




export default function NewProduct() {
  const hoverBg = useColorModeValue('gray.50', 'gray.700');
  const textColor = useColorModeValue('black', 'white');

  // Tokens de color usados más abajo en el formulario. Se declaran aquí, antes
  // del "if (isSoloLectura()) return (...)", porque los Hooks de React deben
  // llamarse siempre en el mismo orden en cada render — si se llaman inline
  // dentro del JSX que viene después de ese return condicional, en el render
  // de solo-lectura simplemente no se ejecutan, lo que rompe esa regla.
  const boxSectionBorder = useColorModeValue('gray.200', 'gray.600');
  const boxSectionBg = useColorModeValue('gray.50', 'gray.700');
  const inputHoverBorder = useColorModeValue('gray.300', 'gray.500');
  const inputFocusBorder = useColorModeValue('blue.400', 'blue.300');
  const inputFocusShadowColor = useColorModeValue('#4299E1', '#63B3ED');
  const inputTextColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const mutedTextColor = useColorModeValue('gray.500', 'gray.400');
  const warningBg = useColorModeValue('orange.50', 'gray.700');
  const warningBorder = useColorModeValue('orange.200', 'orange.400');
  const warningIconColor = useColorModeValue('orange.500', 'orange.300');
  const warningTextColor = useColorModeValue('orange.800', 'orange.200');
  const warningCloseColor = useColorModeValue('orange.600', 'orange.200');
  const folioBoxBorder = useColorModeValue('blue.200', 'blue.500');
  const folioBoxBg = useColorModeValue('blue.50', 'whiteAlpha.100');
  const folioPrefixBg = useColorModeValue('gray.100', 'gray.800');
  const folioPrefixColor = useColorModeValue('gray.600', 'gray.300');
  const folioSuffixBg = useColorModeValue('white', 'gray.700');

  const theme = useTheme();
  const navigate = useNavigate();
  const toast = useToast();

  const [lineColor, setLineColor] = useState(theme.colors.brand[500]);
  const [lineColorDark, setLineColorDark] = useState(theme.colors.brand[400]);
  const brand = useColorModeValue(lineColor, lineColorDark);
  const [filteredFamilias, setFilteredFamilias] = useState<any[]>([]);
  const userId = JSON.parse(sessionStorage.getItem('user'));
  const usuarioId = userId.Id;

  // Estado para mostrar/ocultar el folio sugerido
  const [showSuggestedFolio, setShowSuggestedFolio] = useState(false);
  const [showOtraMarca, setShowOtraMarca] = useState(false);
  const [showOtroModelo, setShowOtroModelo] = useState(false);
  const [showOtroProveedor, setShowOtroProveedor] = useState(false);
  const [deptWarningVisible, setDeptWarningVisible] = useState(false);
  const [arrendadoras, setArrendadoras] = useState<any[]>([]);
  const [isCreatingArrendadora, setIsCreatingArrendadora] = useState(false);
  const [tiposAdquisicion, setTiposAdquisicion] = useState<any[]>([]);
  const [rubrosDepreciacion, setRubrosDepreciacion] = useState<any[]>([]);

const buscarImagenModelo = async (modeloId: string, hotelId: string) => {
  try {
    // 1. Obtener la URL de la imagen desde tu API
    const response = await fetch(`https://inventariosbackend.velasresorts.com/inventarios/get-image-url`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modeloId, hotelId })
    });

    const data = await response.json();

    if (data.url) {
      // 2. Descargar la imagen directamente (sin proxy)
      const imageRes = await fetch(data.url);
      
      if (!imageRes.ok) throw new Error('No se pudo descargar la imagen del servidor');

      const blob = await imageRes.blob();
      
      // 3. Convertir a File para que sea compatible con tu lógica de 'FormData'
      const file = new File([blob], `modelo_${modeloId}.jpg`, { type: blob.type });
      
      // 4. Actualizar el estado y mostrar notificación
      setImagenFile(file);

      toast({
        title: 'Coincidencia encontrada',
        description: 'Se ha asignado la imagen del modelo automáticamente.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    }
  } catch (error) {
    console.error("Error al procesar la imagen del modelo:", error);
    // Opcional: Notificar al usuario si la descarga falló por CORS u otro motivo
  }
};

  const consultarQrListado = async () => {
    try {
      const listado = await qrsApi.listado();
      console.log('Listado de QRs:', listado);
      return listado;
    } catch (error) {
      console.error('Error al consultar listado de QRs:', error);
      return [];
    }
  };

  const idQr = consultarQrListado();

  // Estado del formulario
const [formData, setFormData] = useState<FormData>({
  ActiveName: '',
  LineaId: '',
  FamiliaId: '',
  SubfamiliaId: '',
  MarcaId: '',
  ModeloId: '',
  SerialNumber: '',
  HotelId: '',
  DepartamentoId: '',
  EstadosId: '',
  ProveedorId: '',
  FacturaId: '',
  Precio: '',
  Precio_depreciado: '',
  Garantia: '', // Mantener por compatibilidad
  GarantiaMeses: '', // Nuevo campo
  FechaGarantia: '', // Nuevo campo
  PermitidoSalir: false,
  Status: 'active',
  UsuariosId: usuarioId,
  dropzone: 'holaxD',
  imagenBase64: '',
  QRId: sessionStorage.getItem('qrId') || '',
  Folio: '',
  OtraMarca: '',
  OtroModelo: '',
  OtroProveedor: '',
  Descripcion: '', // 👈 nuevo
  SinGarantia: false,
  TieneArrendamiento: false,
  ArrendadoraId: '',
  TipoAdquisicionId: '',
  CategoriaDepreciacionId: '',
  UbicacionExacta: '',
  FechaAdquisicion: '',
});

  // Estados para los picklists
  const [lineas, setLineas] = useState<any[]>([]);
  const [familias, setFamilias] = useState<any[]>([]);
  const [subfamilias, setSubfamilias] = useState<any[]>([]);
  const [marcas, setMarcas] = useState<any[]>([]);
  const [modelos, setModelos] = useState<any[]>([]);
  const [hoteles, setHoteles] = useState<any[]>([]);
  const [hotelesUsuarios, setHotelesUsuarios] = useState<any[]>([]);
  const [departamentos, setDepartamentos] = useState<any[]>([]);
  const [estados, setEstados] = useState<any[]>([]);
  const [proveedores, setProveedores] = useState<any[]>([]);
  const [facturas, setFacturas] = useState<any[]>([]);
  const [imagenFile, setImagenFile] = useState<File | null>(null);
  const [qrGenerado, setQrGenerado] = useState(false);
  const [qrCodeData, setQrCodeData] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
// Agregar un nuevo estado para el loading
const [isGeneratingQR, setIsGeneratingQR] = useState(false);


const [folioSuffixInput, setFolioSuffixInput] = useState('');
// Agregar este estado después de los otros estados
const [serialNumberError, setSerialNumberError] = useState<string>('');
const [isCheckingSerial, setIsCheckingSerial] = useState(false);
  // Función para validar todos los campos obligatorios



  const verificarSerialDuplicado = async (serialNumber: string): Promise<boolean> => {
  if (!serialNumber.trim()) return false;
  
  try {
    setIsCheckingSerial(true);
    const activos = await activosApi.listado();
    
    // Normalizar el número de serie (quitar espacios, mayúsculas/minúsculas)
    const normalizedInput = serialNumber.toLowerCase().trim();
    
    // Buscar coincidencias exactas
    const serialExistente = activos.find((activo: any) => {
      if (!activo.SerialNumber) return false;
      return activo.SerialNumber.toLowerCase().trim() === normalizedInput;
    });

    if (serialExistente) {
      setSerialNumberError(`El número de serie "${serialNumber}" ya existe en el sistema (Activo ID: ${serialExistente.Id})`);
      return true;
    } else {
      setSerialNumberError('');
      return false;
    }
  } catch (error) {
    console.error('Error al verificar número de serie:', error);
    setSerialNumberError('Error al verificar el número de serie. Intenta nuevamente.');
    return false;
  } finally {
    setIsCheckingSerial(false);
  }
};

const validateAllFields = (): boolean => {
  // Campos obligatorios
  const requiredFields = [
    'ActiveName',
    'LineaId',
    'FamiliaId',
    'ModeloId',
    'SerialNumber',
    'HotelId',
    'DepartamentoId',
    'EstadosId',
    'ProveedorId',
    'Precio',
    'Folio',
    'TipoAdquisicionId',
    ...(formData.SinGarantia ? [] : ['GarantiaMeses']),
    ...(formData.TieneArrendamiento ? ['ArrendadoraId'] : []),
  ];

  // Validar campos básicos
  const basicFieldsValid = requiredFields.every(field => {
    const value = formData[field as keyof FormData];
    return value !== '' && value !== undefined && value !== null;
  });

  // Validar marca
  const marcaValid = formData.MarcaId !== 'otro' || 
    (formData.MarcaId === 'otro' && formData.OtraMarca !== '');

  // Validar modelo
  const modeloValid = formData.ModeloId !== 'otro' || 
    (formData.ModeloId === 'otro' && formData.OtroModelo !== '');

  // Validar proveedor
  const proveedorValid = formData.ProveedorId !== 'otro' || 
    (formData.ProveedorId === 'otro' && formData.OtroProveedor !== '');

  // Validar número de serie (no duplicado y longitud mínima)
  const serialValid = formData.SerialNumber.trim().length >= 3 && 
    serialNumberError === '';

  return basicFieldsValid && marcaValid && modeloValid && proveedorValid && serialValid;
};
  
  // Función para calcular la fecha de garantía basada en meses
const calcularFechaGarantia = (meses: string): string => {
  if (!meses || isNaN(Number(meses)) || Number(meses) <= 0) {
    return '';
  }
  
  const fechaActual = new Date();
  const fechaGarantia = new Date();
  fechaGarantia.setMonth(fechaGarantia.getMonth() + Number(meses));
  
  // Formatear a YYYY-MM-DD
  return fechaGarantia.toISOString().split('T')[0];
};

  const generateSuggestedFolio = async () => {
    try {
      if (!formData.FamiliaId) {
        toast({
          title: 'Selecciona una sublínea primero',
          description: 'Debes seleccionar una sublínea (familia) para generar el folio',
          status: 'warning',
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const response = await fetch(`https://inventariosbackend.velasresorts.com/inventarios/getConsecutivo?FamiliaId=${formData.FamiliaId}`);

      if (!response.ok) {
        throw new Error('Error al obtener el folio');
      }

      const data = await response.json();

      if (!data.success || !data.folio) {
        throw new Error('No se pudo generar el folio');
      }

      setFormData(prev => ({ ...prev, Folio: data.folio }));
      setShowSuggestedFolio(true);

      toast({
        title: 'Folio generado',
        description: `Se ha generado el folio: ${data.folio}`,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error al generar folio:', error);
      toast({
        title: 'Error',
        description: 'No se pudo generar el folio. Verifica que hayas seleccionado una sublínea válida.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const getFechaActual = () => {
    const fecha = new Date();
    const opciones: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'America/Mexico_City'
    };
    return fecha.toLocaleDateString('es-MX', opciones);
  }

const handleGenerateQR = async () => {
  setFormSubmitted(true);

  if (!validateAllFields()) {
    toast({
      title: 'Campos incompletos',
      description: 'Por favor completa todos los campos obligatorios',
      status: 'warning',
      duration: 5000,
      isClosable: true,
    });
    return;
  }

  if (!formData.SerialNumber) {
    toast({
      title: 'Número de serie faltante',
      description: 'Debe ingresar un número de serie antes de generar el código QR.',
      status: 'warning',
      duration: 5000,
      isClosable: true,
    });
    return;
  }

  if (!formData.Folio) {
    toast({
      title: 'Folio faltante',
      description: 'Espere a que se genere el folio automáticamente o seleccione una sublínea válida.',
      status: 'warning',
      duration: 5000,
      isClosable: true,
    });
    return;
  }

  // Iniciar estado de carga
  setIsGeneratingQR(true);

  try {
    interface QR {
      Id: number;
    }

    interface Activo {
      Id: number;
      Folio: string;
    }

    const listadoQR = await qrsApi.listado() as QR[];
    const lastQR = listadoQR.sort((a: QR, b: QR) => b.Id - a.Id)[0];
    const newQRId = lastQR ? lastQR.Id + 1 : 1;

    const listadoActivo = await activosApi.listado() as Activo[];
    const lastActivo = listadoActivo.sort((a: Activo, b: Activo) => b.Id - a.Id)[0];
    const newIdActivo = lastActivo ? lastActivo.Id + 1 : 1;

    const folioQR = formData.Folio;
    const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://inventariosbackend.velasresorts.com/inventarios/check/qr/${encodeURIComponent(folioQR)}`;

    const response = await fetch(qrUrl);
    const blob = await response.blob();
    const reader = new FileReader();

    reader.onloadend = async () => {
      try {
        const base64data = reader.result as string;

        const postResponse = await fetch('https://inventariosbackend.velasresorts.com/inventarios/qr/crear', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Id: newQRId,
            ActivoId: newIdActivo,
            CodigoQR: folioQR,
            Metadata: base64data,
            FechaGeneracion: getFechaActual(),
            Estado: 'activo',
            CreatedDate: getFechaActual(),
            LastModifiedDate: getFechaActual(),
          }),
        });

        if (!postResponse.ok) {
          const errorText = await postResponse.text();

          if (errorText.includes("Duplicate")) {
            throw new Error("Ese Folio ya fue asignado a otro activo. Por favor, genera un folio diferente.");
          }

          throw new Error(`Error al enviar el QR: ${postResponse.status} ${postResponse.statusText} → ${errorText}`);
        }

        const qrData = await postResponse.json();
        console.log('QR creado:', qrData);

        const { SinGarantia, ...restFormData } = formData;
        const formDataConQR = {
          ...restFormData,
          QRId: qrData[0].insertId?.toString() ?? '',
          Garantia: SinGarantia ? null : restFormData.Garantia,
        };

        await activosApi.crear(formDataConQR);

        if (imagenFile) {
          const form = new FormData();
          Object.entries(formDataConQR).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              form.append(key, value.toString());
            }
          });
          form.append('imagen', imagenFile);

          const uploadRes = await fetch('https://inventariosbackend.velasresorts.com/inventarios/imagenes/crear', {
            method: 'POST',
            body: form,
          });

          if (!uploadRes.ok) {
            const errorText = await uploadRes.text();
            throw new Error(`Error al subir imagen: ${uploadRes.status} ${uploadRes.statusText} → ${errorText}`);
          }

          console.log(await uploadRes.json());
        }

        toast({
          title: 'Activo guardado',
          description: `El activo con folio ${folioQR} y su código QR se generaron correctamente.`,
          status: 'success',
          duration: 5000,
          isClosable: true,
        });

        setQrCodeData(qrUrl);
        setQrGenerado(true);
        
        // Finalizar estado de carga antes de navegar
        setIsGeneratingQR(false);
        
        setTimeout(() => {
          navigate('/admin/main/ecommerce/order-list');
        }, 1000); // Pequeña pausa para mostrar el mensaje de éxito

      } catch (err: any) {
        console.error('❌ Error en creación de QR o subida:', err);
        setIsGeneratingQR(false); // Finalizar estado de carga en caso de error

        toast({
          title: 'Error',
          description: err.message || 'Ocurrió un error inesperado',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };

    reader.readAsDataURL(blob);

  } catch (error) {
    console.error('Error al generar o guardar QR/activo:', error);
    setIsGeneratingQR(false); // Finalizar estado de carga en caso de error
    
    toast({
      title: 'Error',
      description: 'Ocurrió un problema al guardar el QR y el activo.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  }
};

  // Manejadores de cambios
const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { id, value } = e.target;

  // Validar campos numéricos (Precio y Precio_depreciado)
  if (id === 'Precio' || id === 'Precio_depreciado') {
    // Permitir solo números y punto decimal
    const numericRegex = /^[0-9]*\.?[0-9]*$/;
    if (value !== '' && !numericRegex.test(value)) {
      // Mostrar advertencia si no es un número válido
      toast({
        title: 'Valor inválido',
        description: 'Este campo solo acepta números',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return; // No actualizar el estado si no es válido
    }
  }

    // ✅ NUEVA LÓGICA PARA GARANTÍA EN MESES
  if (id === 'GarantiaMeses') {
    // Validar que sea un número positivo
    const mesesValue = value.trim();
    if (mesesValue !== '' && (!/^\d+$/.test(mesesValue) || Number(mesesValue) <= 0)) {
      toast({
        title: 'Valor inválido',
        description: 'La garantía debe ser un número de meses mayor a 0',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Calcular fecha de garantía
    const fechaGarantia = calcularFechaGarantia(mesesValue);
    
    setFormData(prev => ({ 
      ...prev, 
      GarantiaMeses: mesesValue,
      FechaGarantia: fechaGarantia,
      Garantia: fechaGarantia // Mantener compatibilidad con el campo original
    }));
    return;
  }

  if (id === 'SerialNumber') {
    setFormData(prev => ({ ...prev, SerialNumber: value }));
    if (value.trim().length > 0 && value.trim().length < 3) {
      setSerialNumberError('El número de serie debe tener al menos 3 caracteres');
    } else {
      setSerialNumberError('');
    }
    return;
  }

  // Resto de validaciones (Garantía)
/*   if (id === 'Garantia') {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (value && !dateRegex.test(value)) {
      toast({
        title: 'Formato de fecha incorrecto',
        description: 'Por favor use el formato YYYY-MM-DD',
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const selectedDate = new Date(value);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (value && selectedDate < currentDate) {
       toast({
         title: 'Fecha inválida',
         description: 'La fecha de garantía no puede ser anterior a la fecha actual',
         status: 'warning',
         duration: 5000,
         isClosable: true,
       });
       return;
     } 
  } */

  if (id === 'OtroProveedor') {
    const nuevoProveedor = value;

    // Función para normalizar el texto
    const normalizeText = (text: string) => {
      return text
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    };

    // Verificar si el proveedor ya existe
    const proveedorExistente = proveedores.find(proveedor =>
      normalizeText(proveedor.Proveedor) === normalizeText(nuevoProveedor)
    );

    if (proveedorExistente && nuevoProveedor.trim() !== '') {
      toast({
        title: 'Proveedor ya existe',
        description: `El proveedor "${nuevoProveedor}" ya existe en la lista. Por favor selecciónalo del menú desplegable.`,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });

      setFormData(prev => ({ ...prev, OtroProveedor: '' }));
      return;
    }
  }

  // Actualizar el estado si pasa todas las validaciones
  setFormData(prev => ({ ...prev, [id]: value }));
};

  const handleSelectChange = (id: string, value: string) => {
    console.log(`Cambiando ${id} a:`, value);

    // Manejar selección de "Otro" para marca y modelo
    if (id === 'MarcaId') {
      setShowOtraMarca(value === 'otro');
      if (value !== 'otro') {
        setFormData(prev => ({ ...prev, OtraMarca: '' }));
      }
    }

    if (id === 'ModeloId') {
    setShowOtroModelo(value === 'otro');
    if (value !== 'otro') {
      setFormData(prev => ({ ...prev, OtroModelo: '' }));
      // 🚀 DISPARAR BÚSQUEDA DE IMAGEN
      // Usamos el value (id del modelo) y el hotelId que ya está en formData
      if (value && sessionStorage.getItem('hotelSeleccionado')) {
        buscarImagenModelo(value, sessionStorage.getItem('hotelSeleccionado'));
      }
    }
  }

    if (id === 'ProveedorId') {
      setShowOtroProveedor(value === 'otro');
      if (value !== 'otro') {
        setFormData(prev => ({ ...prev, OtroProveedor: '' }));
      }
    }

setFormData(prev => {
    const newData = { ...prev, [id]: value };
    if (id === 'LineaId') {
      newData.FamiliaId = '';
      newData.SubfamiliaId = '';
    } else if (id === 'FamiliaId') {
      newData.SubfamiliaId = '';
    }
    return newData;
  });

  };

  const handleToggleChange = (id: string, value: boolean) => {
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleCreateArrendadora = async (nombre: string) => {
    const nombreLimpio = nombre.trim();
    if (!nombreLimpio) return;

    setIsCreatingArrendadora(true);
    try {
      const nueva = await arrendadorasApi.crear(nombreLimpio);
      setArrendadoras(prev => [...prev, nueva]);
      setFormData(prev => ({ ...prev, ArrendadoraId: nueva.Id.toString() }));
      toast({
        title: 'Arrendadora creada',
        description: `"${nueva.Name}" se agregó al catálogo de arrendadoras.`,
        status: 'success',
        duration: 4000,
        isClosable: true,
      });
    } catch (error: any) {
      const mensaje = error?.response?.data?.error || 'No se pudo crear la arrendadora.';
      toast({
        title: 'Error al crear arrendadora',
        description: mensaje,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsCreatingArrendadora(false);
    }
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const maxWidth = 1024; // ancho máximo
      const scaleSize = maxWidth / img.width;
      canvas.width = maxWidth;
      canvas.height = img.height * scaleSize;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        if (blob) {
          const newFile = new File([blob], file.name, { type: file.type });
          setImagenFile(newFile);
        }
      }, file.type, 0.8); // calidad 80%
    };
  };


  const hotelesCatalogo = [
    { value: '1', label: 'Grand Velas Riviera Nayarit' },
    { value: '2', label: 'Grand Velas Riviera Maya' },
    { value: '3', label: 'Grand Velas Boutique Los Cabos' },
    { value: '4', label: 'Grand Velas Los Cabos' },
    { value: '5', label: 'Velas Vallarta' },
    { value: '6', label: 'Casa Velas' },
    { value: '7', label: 'Mar del Cabo' },
    { value: '8', label: 'Contact Center' },
  ];

  const hotelesCatalogoSelect = [
    { value: 'GVRN', label: 'Grand Velas Riviera Nayarit' },
    { value: 'GVRM', label: 'Grand Velas Riviera Maya' },
    { value: 'GVBLC', label: 'Grand Velas Boutique Los Cabos' },
    { value: 'GVLC', label: 'Grand Velas Los Cabos' },
    { value: 'VV', label: 'Velas Vallarta' },
    { value: 'CV', label: 'Casa Velas' },
    { value: 'MDC', label: 'Mar del Cabo' },
    { value: 'CC', label: 'Contact Center' },
    { value: 'DEMO', label: 'Hotel Demo' },
  ];

  useEffect(() => {
    if (formData.LineaId && familias.length > 0) {
      const filtered = familias.filter(familia =>
        familia.LineaId && familia.LineaId.toString() === formData.LineaId
      );
      setFilteredFamilias(filtered);

      if (formData.FamiliaId && !filtered.some(f => f.id_sub && f.id_sub.toString() === formData.FamiliaId)) {
        setFormData(prev => ({ ...prev, FamiliaId: '', SubfamiliaId: '' }));
      }
    } else {
      setFilteredFamilias([]);
      setFormData(prev => ({ ...prev, FamiliaId: '', SubfamiliaId: '' }));
    }
  }, [formData.LineaId, familias]);

  useEffect(() => {
  const generarFolioAutomatico = async () => {
    if (formData.FamiliaId && formData.HotelId) {
      try {
        // 1. Sincronización del Hotel (Opcional, pero sin 'return' que corte el flujo)
        const hotelSeleccionadoSigla = sessionStorage.getItem('hotelSeleccionado') || '';
        const hotelSelect = hotelesCatalogoSelect.find(h => h.value === hotelSeleccionadoSigla);
        let currentHotelId = formData.HotelId;

        if (hotelSelect) {
          const hotelNumerico = hotelesCatalogo.find(h => h.label === hotelSelect.label);
          if (hotelNumerico && hotelNumerico.value !== formData.HotelId) {
            currentHotelId = hotelNumerico.value;
            setFormData(prev => ({ ...prev, HotelId: hotelNumerico.value }));
            // No ponemos return aquí para que el fetch use 'currentHotelId' de inmediato
          }
        }

        // 2. Llamada a la API
        const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/getConsecutivo', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            FamiliaId: formData.FamiliaId,
            HotelId: currentHotelId // Usamos la variable local actualizada
          })
        });

          if (!response.ok) {
            throw new Error('Error al obtener el folio');
          }

          const data = await response.json();

          if (!data.success || !data.folio) {
            throw new Error('No se pudo generar el folio');
          }

setFormData(prev => ({ ...prev, Folio: data.folio.folio }));
setShowSuggestedFolio(true);

// nuevo: sincronizar sufijo visible
const folioStr = data.folio.folio as string;          // "CC-034-000023"
const lastDashIndex = folioStr.lastIndexOf('-');
const suffix = lastDashIndex !== -1
  ? folioStr.slice(lastDashIndex + 1)
  : folioStr;

setFolioSuffixInput(suffix); // "000023"

        } catch (error) {
          console.error('Error al generar folio automáticamente:', error);
          toast({
            title: 'Error',
            description: 'No se pudo generar el folio automáticamente',
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        }
      }
    };

    generarFolioAutomatico();
  }, [formData.FamiliaId, formData.HotelId]);

  // Depreciación mensual = Costo x (% anual del rubro / 100) / 12
  useEffect(() => {
    const precio = parseFloat(formData.Precio);
    const rubro = rubrosDepreciacion.find(r => r.Id.toString() === formData.CategoriaDepreciacionId);
    if (!isNaN(precio) && rubro) {
      const mensual = (precio * (Number(rubro.Porcentaje) / 100) / 12).toFixed(2);
      setFormData(prev => ({ ...prev, Precio_depreciado: mensual }));
    } else {
      setFormData(prev => ({ ...prev, Precio_depreciado: '' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.Precio, formData.CategoriaDepreciacionId, rubrosDepreciacion]);

  // El % de cada rubro puede cambiar de un año a otro (ej. Edificio 1% en 2025,
  // 5% en 2026), y cada fila de la tabla es específica de un año. Por eso el
  // listado de rubros debe corresponder al año de la Fecha de Adquisición del
  // activo (no al año actual): si el activo se adquirió en 2025, debe poder
  // elegirse la tabla de 2025, aunque hoy ya estemos en 2026.
  useEffect(() => {
    const anio = formData.FechaAdquisicion
      ? Number(formData.FechaAdquisicion.split('-')[0])
      : new Date().getFullYear();

    const cargarRubrosDelAnio = async () => {
      const data = await depreciacionApi.listado(anio);
      const rubros = Array.isArray(data) ? data : [];
      setRubrosDepreciacion(rubros);

      // Si el rubro ya elegido no existe en la tabla del nuevo año (los Id son
      // específicos de cada año), se limpia para no dejar guardado un % que
      // no corresponde a la fecha de adquisición.
      setFormData(prev => {
        if (prev.CategoriaDepreciacionId && !rubros.some(r => r.Id.toString() === prev.CategoriaDepreciacionId)) {
          return { ...prev, CategoriaDepreciacionId: '' };
        }
        return prev;
      });
    };

    cargarRubrosDelAnio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.FechaAdquisicion]);

  // Cargar datos de los picklists
  useEffect(() => {
    const fetchActivos = async () => {
      try {
        const [
          lineasData,
          familiasData,
          subfamiliasData,
          marcasData,
          modelosData,
          hotelesData,
          userHotelesData,
          departamentosData,
          estadosData,
          proveedoresData,
          facturasData,
          arrendadorasData,
          tiposAdquisicionData,
        ] = await Promise.all([
          lineasApi.listado(),
          familiasApi.listado(),
          subfamiliasApi.listado(),
          marcasApi.listado(),
          modelosApi.listado(),
          hotelesApi.listado(),
          hotelesApi.listadoUsuariosHoteles(),
          departamentosApi.listado(),
          estadosApi.listado(),
          proveedoresApi.listado(),
          facturasApi.listado(),
          arrendadorasApi.listado(),
          tipoAdquisicionApi.listado(),
        ]);

        setLineas(lineasData);
        setFamilias(familiasData);
        setSubfamilias(subfamiliasData);
        setMarcas(marcasData);
        setModelos(modelosData);
        setHoteles(hotelesData);
        setHotelesUsuarios(userHotelesData);
        setDepartamentos(departamentosData);
        setEstados(estadosData);
        setProveedores(proveedoresData);
        setFacturas(Array.isArray(facturasData) ? facturasData : []);
        setArrendadoras(Array.isArray(arrendadorasData) ? arrendadorasData : []);
        setTiposAdquisicion(Array.isArray(tiposAdquisicionData) ? tiposAdquisicionData : []);

        const user = JSON.parse(sessionStorage.getItem('user') || '{}');
        const hotelUsuario = userHotelesData.find((hotel: any) => hotel.UsuarioId === user?.Id);

        console.log('Usuario actual:', user);
        console.log('Hotel del usuario:', hotelUsuario);

        if (hotelUsuario?.HotelId || hotelUsuario?.Id) {
          setFormData((prev) => ({
            ...prev,
            HotelId: (hotelUsuario.HotelId || hotelUsuario.Id).toString(),
          }));
        }

      } catch (error) {
        console.error('Error al cargar datos de picklists:', error);
      }
    };

    fetchActivos();
  }, []);

  useEffect(() => {
    if (qrGenerado) {
      setTimeout(() => {
        const el = document.getElementById('qrBox');
        el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }, [qrGenerado]);

  useEffect(() => {
    const esDistinto =
      !!formData.DepartamentoId &&
      !!userId?.DepartamentoId &&
      String(formData.DepartamentoId) !== String(userId.DepartamentoId);

    if (!esDistinto) {
      setDeptWarningVisible(false);
      return;
    }

    setDeptWarningVisible(true);
    const timer = setTimeout(() => setDeptWarningVisible(false), 10000);
    return () => clearTimeout(timer);
  }, [formData.DepartamentoId]);

  useEffect(() => {
    const obtenerQRId = async () => {
      try {
        const listado = await qrsApi.listado();
        const maxId = listado.reduce((max: number, item: { Id: string }) => {
          const id = parseInt(item.Id, 10);
          return id > max ? id : max;
        }, 0);

        const nuevoId = maxId + 1;

        setFormData(prev => ({ ...prev, QRId: nuevoId.toString() }));
      } catch (error) {
        console.error('Error al obtener el nuevo QRId:', error);
      }
    };

    obtenerQRId();
  }, []);

  const user = JSON.parse(sessionStorage.getItem('user'));
  const hotelUsuario = hotelesUsuarios.find(hotel => hotel.UsuarioId === user?.Id);

const folio = formData.Folio || '';
const lastDashIndex = folio.lastIndexOf('-');

const folioPrefix =
  lastDashIndex !== -1 ? folio.slice(0, lastDashIndex + 1) : ''; // "CC-034-"

let folioSuffix =
  lastDashIndex !== -1 ? folio.slice(lastDashIndex + 1) : folio;

// Asegura longitud 6 solo para mostrar inicialmente
folioSuffix = (folioSuffix || '').padStart(6, '0');

// Aviso: el departamento seleccionado es distinto al del usuario
const miDepartamento = departamentos.find(d => String(d.Id) === String(userId?.DepartamentoId));
const departamentoSeleccionado = departamentos.find(d => String(d.Id) === String(formData.DepartamentoId));
const departamentoDistintoAlUsuario =
  !!formData.DepartamentoId &&
  !!userId?.DepartamentoId &&
  String(formData.DepartamentoId) !== String(userId.DepartamentoId);



  if (isSoloLectura()) {
    return <Navigate to="/admin/main/ecommerce/order-list" replace />;
  }

  return (
    <Flex direction="column" minH="100vh" align="center" pt={{ sm: '125px', lg: '75px' }} position="relative">
      <Card mb="200px" p="30px">
        <Flex justify="space-between" align="center" mb="20px">
          <Text color={textColor} fontSize="2xl" fontWeight="700">
            Información del Activo
          </Text>
          <Button ml="10px" onClick={() => navigate('/admin/main/ecommerce/order-list')}>
            <Icon as={MdArrowBack} w='16px' h='16px' mr='5px' color={textColor} />
            Volver al Listado
          </Button>
        </Flex>

        <Flex direction="column" w="100%">
          <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px" mb="20px">
            <Stack direction="column" gap="20px">
              {/* Nombre */}
              <InputField
                mb="0px"
                id="ActiveName"
                label="Nombre"
                placeholder="Nombre del activo"
                required={true}
                value={formData.ActiveName}
                onChange={handleInputChange}
                isInvalid={formSubmitted && !formData.ActiveName}
              />

              {/* Linea */}
              <SelectField
                id="LineaId"
                label="Selecciona una línea"
                placeholder="Selecciona una línea"
                required={true}
                mb="0px"
                isInvalid={formSubmitted && !formData.LineaId}
                options={lineas
                  .filter(linea => {
                    const hotelSeleccionado = sessionStorage.getItem("hotelSeleccionado");
                    if (hotelSeleccionado === "CC") {
                      return linea.id_linea === 38 || linea.id_linea === 27;
                    }
                    return true;
                  })
                  .map(linea => ({
                    value: linea.id_linea.toString(),
                    label: linea.nom_linea
                  }))
                }
                value={formData.LineaId}
                onChange={(value: string) => handleSelectChange("LineaId", value)}
              />


              {/* Familia */}
              <SelectField
                id="FamiliaId"
                label="Selecciona una sublínea"
                placeholder={
                  formData.LineaId
                    ? "Selecciona una familia"
                    : "Primero selecciona una línea"
                }
                required={true}
                mb="0px"
                isInvalid={formSubmitted && !formData.FamiliaId}
                isDisabled={!formData.LineaId}
                options={filteredFamilias.map(familia => ({
                  value: familia.id_sub.toString(),
                  label: familia.Name
                }))}
                value={formData.FamiliaId}
                onChange={(value: string) => {
                  handleSelectChange("FamiliaId", value);
                  setFormData(prev => ({ ...prev, SubfamiliaId: "" }));
                }}
              />

              {/* Marca con opción "Otro" */}
              <Box>
                <SelectField
                  id="MarcaId"
                  label="Selecciona una marca"
                  placeholder="Selecciona una marca"
                  mb="0px"
                  options={[
                    ...marcas.map(marca => ({ value: marca.Id, label: marca.Name })),
                    { value: "otro", label: "Otro (especificar)" }
                  ]}
                  value={formData.MarcaId}
                  onChange={(value: string) => handleSelectChange("MarcaId", value)}
                />
                {showOtraMarca && (
                  <Box mt="12px">
                    <InputField
                      id="OtraMarca"
                      placeholder="Especificar marca"
                      value={formData.OtraMarca || ''}
                      mb="0px"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const nuevaMarca = e.target.value;

                        // Función para normalizar el texto (espacios, mayúsculas, etc.)
                        const normalizeText = (text: string) => {
                          return text
                            .toLowerCase()
                            .replace(/\s+/g, ' ') // Reemplaza múltiples espacios por uno solo
                            .trim() // Elimina espacios al inicio y final
                            .normalize("NFD") // Separa acentos de letras
                            .replace(/[\u0300-\u036f]/g, ""); // Elimina acentos
                        };

                        // Verificar si la marca ya existe en la lista (normalizada)
                        const marcaExistente = marcas.find(marca =>
                          normalizeText(marca.Name) === normalizeText(nuevaMarca)
                        );

                        if (marcaExistente && nuevaMarca.trim() !== '') {
                          // Mostrar mensaje de error
                          toast({
                            title: 'Marca ya existe',
                            description: `La marca "${nuevaMarca}" ya existe en la lista. Por favor selecciónala del menú desplegable.`,
                            status: 'warning',
                            duration: 5000,
                            isClosable: true,
                          });

                          // Limpiar el campo y no permitir escribir
                          setFormData(prev => ({ ...prev, OtraMarca: '' }));
                          return;
                        }

                        // Si no existe, permitir el cambio normal
                        handleInputChange(e);
                      }}
                      isInvalid={formSubmitted && !formData.OtraMarca}
                    />
                    {formSubmitted && !formData.OtraMarca && (
                      <Text color="red.500" fontSize="xs" mt="2px">
                        Este campo es obligatorio
                      </Text>
                    )}
                  </Box>
                )}
              </Box>


<Box>
  <SelectField
    id="ModeloId"
    label="Selecciona un modelo"
    placeholder="Selecciona un modelo"
    mb="0px"
    options={[
      ...modelos.map(modelo => ({ value: modelo.Id, label: modelo.Name })),
      { value: 'otro', label: 'Otro (especificar)' }
    ]}
    value={formData.ModeloId}
    onChange={(value: string) => {
      handleSelectChange('ModeloId', value);
      // Mostrar input para "Otro" si se selecciona
      setShowOtroModelo(value === 'otro');
    }}
  />

  {showOtroModelo && (
    <Box mt="12px">
      <InputField
        id="OtroModelo"
        placeholder="Especificar modelo"
        value={formData.OtroModelo || ''}
        mb="0px"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const nuevoModelo = e.target.value;

          const normalizeText = (text: string) => {
            return text
              .toLowerCase()
              .replace(/\s+/g, ' ')
              .trim()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
          };

          const modeloExistente = modelos.find(modelo =>
            normalizeText(modelo.Name) === normalizeText(nuevoModelo)
          );

          if (modeloExistente && nuevoModelo.trim() !== '') {
            toast({
              title: 'Modelo ya existe',
              description: `El modelo "${nuevoModelo}" ya existe en la lista. Por favor selecciónalo del menú desplegable.`,
              status: 'warning',
              duration: 5000,
              isClosable: true,
            });
            setFormData(prev => ({ ...prev, OtroModelo: '' }));
            return;
          }

          handleInputChange(e);
        }}
        isInvalid={formSubmitted && !formData.OtroModelo}
      />
      {formSubmitted && !formData.OtroModelo && (
        <Text color="red.500" fontSize="xs" mt="2px">
          Este campo es obligatorio
        </Text>
      )}
    </Box>
  )}
</Box>



              {/* Número de Serie */}
<Box>
  <InputField
    id="SerialNumber"
    label="Número de serie"
    placeholder="ABC12345-XYZ67890"
    required={true}
    mb="0px"
    value={formData.SerialNumber}
    onChange={handleInputChange}
    onBlur={() => {
      if (formData.SerialNumber.trim().length >= 3) {
        verificarSerialDuplicado(formData.SerialNumber);
      }
    }}
    isInvalid={(formSubmitted && !formData.SerialNumber) || serialNumberError !== ''}
  />

  {isCheckingSerial && (
    <Text fontSize="xs" color="blue.500" mt="2px">
      Verificando número de serie...
    </Text>
  )}
  
  {serialNumberError && !isCheckingSerial && (
    <Text color="red.500" fontSize="xs" mt="2px">
      {serialNumberError}
    </Text>
  )}
  
  {formSubmitted && !formData.SerialNumber && !serialNumberError && (
    <Text color="red.500" fontSize="xs" mt="2px">
      Este campo es obligatorio
    </Text>
  )}
  
  {!serialNumberError && formData.SerialNumber.length >= 3 && !isCheckingSerial && (
    <Text color="green.500" fontSize="xs" mt="2px">
      ✓ Número de serie disponible
    </Text>
  )}
</Box>

{/* Campo de Garantía en Meses */}
<Box>
  <Checkbox
    mb="12px"
    isChecked={formData.SinGarantia}
    onChange={(e) =>
      setFormData(prev => ({
        ...prev,
        SinGarantia: e.target.checked,
        ...(e.target.checked
          ? { GarantiaMeses: '', FechaGarantia: '', Garantia: '' }
          : {}),
      }))
    }
    colorScheme="brand"
  >
    <Text fontSize="sm" color="gray.600">No cuenta con garantía</Text>
  </Checkbox>

  <InputField
    id="GarantiaMeses"
    label="Garantía (meses)"
    type="number"
    placeholder="Ej: 12, 24, 36"
    required={!formData.SinGarantia}
    mb="0px"
    value={formData.GarantiaMeses}
    onChange={handleInputChange}
    min="1"
    isDisabled={formData.SinGarantia}
    isInvalid={formSubmitted && !formData.SinGarantia && !formData.GarantiaMeses}
  />
  {formSubmitted && !formData.SinGarantia && !formData.GarantiaMeses && (
    <Text color="red.500" fontSize="xs" mt="5px">
      Este campo es obligatorio
    </Text>
  )}
  {formData.FechaGarantia && !formData.SinGarantia && (
    <Text fontSize="xs" color="gray.600" mt="2px">
      Fecha de vencimiento: {new Date(formData.FechaGarantia).toLocaleDateString('es-MX')}
    </Text>
  )}
  {formData.SinGarantia && (
    <Text fontSize="xs" color="orange.500" mt="2px">
      Este activo no cuenta con garantía
    </Text>
  )}
</Box>

{/* Fecha de adquisición */}
<InputField
  id="FechaAdquisicion"
  label="Fecha de adquisición"
  type="date"
  placeholder="Fecha en que se adquirió el activo"
  value={formData.FechaAdquisicion || ''}
  onChange={handleInputChange}
  mb="0px"
/>
<Box
  mt="24px"
  p="16px"
  borderRadius="16px"
  border="1px solid"
  borderColor={boxSectionBorder}
  bg={boxSectionBg}
>
  <Text fontSize="lg" fontWeight="700" mb="8px" color={textColor}>
    Descripción del activo
  </Text>

  <Text fontSize="sm" color="gray.500" mb="8px">
    Agrega detalles como estado, ubicación específica, características o notas internas.
  </Text>

<Textarea
  id="Descripcion"
  placeholder="Ejemplo: Pantalla de 55 pulgadas ubicada en sala de juntas, con control remoto y base de pared incluidos."
  value={formData.Descripcion || ''}
  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
    setFormData(prev => ({ ...prev, Descripcion: e.target.value }))
  }
  fontSize="sm"
  fontWeight="medium"
  borderRadius="10px"
  borderWidth="1px"
  borderColor={boxSectionBorder}
  minH="120px"
  _hover={{
    borderColor: inputHoverBorder,
  }}
  _focus={{
    borderColor: inputFocusBorder,
    boxShadow: `0 0 0 2px ${inputFocusShadowColor}`,
  }}
  bg={boxSectionBg}
  color={inputTextColor}
  _placeholder={{ color: mutedTextColor }}
/>

</Box>
            </Stack>

            <Stack direction="column" gap="20px">
              {/* Hotel */}
              {(() => {
                const hotelSeleccionadoSigla = sessionStorage.getItem('hotelSeleccionado') || '';
                const hotelSelect = hotelesCatalogoSelect.find(h => h.value === hotelSeleccionadoSigla);
                const nombreHotel = hotelSelect ? hotelSelect.label : hotelSeleccionadoSigla;
                const hotelNumerico = hotelesCatalogo.find(h => h.label === nombreHotel);
                const valueNumerico = hotelNumerico ? hotelNumerico.value : '';

                return (
                  <InputField
                    id="HotelSeleccionado"
                    placeholder="Hotel"
                    label="Hotel"
                    value={nombreHotel}
                    isReadOnly
                    onChange={() => { }}
                    mb="0px"
                  />
                );
              })()}

              {/* Departamento */}
              <Box position="relative">
                <SelectField
                  id="DepartamentoId"
                  label="Selecciona un departamento"
                  placeholder="Selecciona un departamento"
                  required={true}
                  mb="0px"
                  isInvalid={formSubmitted && !formData.DepartamentoId}
                  options={(() => {
                    const permitidos = getDepartamentosPermitidos();
                    return permitidos === null
                      ? departamentos
                      : departamentos.filter(d => permitidos.includes(Number(d.Id)));
                  })()
                    .map(departamento => ({
                      value: departamento.Id,
                      label: departamento.Name
                    }))
                  }
                  value={formData.DepartamentoId}
                  onChange={(value: string) => handleSelectChange("DepartamentoId", value)}
                />

                {departamentoDistintoAlUsuario && deptWarningVisible && (
                  <Flex
                    position="absolute"
                    top="100%"
                    left="0"
                    mt="6px"
                    zIndex={10}
                    maxW="320px"
                    p="10px 12px"
                    borderRadius="10px"
                    boxShadow="lg"
                    align="flex-start"
                    gap="8px"
                    bg={warningBg}
                    border="1px solid"
                    borderColor={warningBorder}
                  >
                    <Icon
                      as={MdOutlineInfo}
                      color={warningIconColor}
                      w="16px"
                      h="16px"
                      mt="1px"
                      flexShrink={0}
                    />
                    <Text fontSize="xs" color={warningTextColor} lineHeight="1.4" pr="4px">
                      Eres usuario del departamento <Text as="span" fontWeight="700">{miDepartamento?.Name || 'sin asignar'}</Text>.
                      {' '}Si seleccionas un departamento diferente, estás indicando que este activo le pertenece a{' '}
                      <Text as="span" fontWeight="700">{departamentoSeleccionado?.Name}</Text>.
                    </Text>
                    <CloseButton
                      size="sm"
                      color={warningCloseColor}
                      onClick={() => setDeptWarningVisible(false)}
                      flexShrink={0}
                    />
                  </Flex>
                )}
              </Box>

              {/* Ubicación exacta */}
              <InputField
                id="UbicacionExacta"
                label="Ubicación exacta"
                placeholder="Ej. Piso 3, habitación 305, closet de TV"
                value={formData.UbicacionExacta || ''}
                onChange={handleInputChange}
                mb="0px"
              />

              {/* Estado */}
              <SelectField
                id="EstadosId"
                label="Selecciona un estado"
                placeholder="Selecciona un estado"
                required={true}
                mb="0px"
                isInvalid={formSubmitted && !formData.EstadosId}
                //agregamos estado bodega y rma
                options={estados
                  .filter(estado => estado.Name === "active" || estado.Name === "bodega" || estado.Name === "rma")
                  .map(estado => ({
                    value: estado.Id,
                    label: estado.Name === "rma" ? "RMA" : estado.Name
                  }))
                }
                value={formData.EstadosId}
                onChange={(value: string) => handleSelectChange("EstadosId", value)}
              />



              {/* Proveedor */}
              <Box>
              <SelectField
                id="ProveedorId"
                placeholder="Selecciona un proveedor"
                label="Proveedor"
                required={true}
                mb="0px"
                options={[
                  ...proveedores.map(proveedor => ({ value: proveedor.Id.toString(), label: proveedor.Proveedor })),
                  { value: 'otro', label: 'Otro (especificar)' }
                ]}
                onChange={(value: string) => handleSelectChange('ProveedorId', value)}
                value={formData.ProveedorId}
                isInvalid={formSubmitted && !formData.ProveedorId}
              />
              {showOtroProveedor && (
                <Box mt="12px">
                  <InputField
                    id="OtroProveedor"
                    placeholder="Especificar proveedor"
                    value={formData.OtroProveedor || ''}
                    mb="0px"
                    onChange={handleInputChange}
                    isInvalid={formSubmitted && !formData.OtroProveedor}
                  />
                  {formSubmitted && !formData.OtroProveedor && (
                    <Text color="red.500" fontSize="xs" mt="2px">
                      Este campo es obligatorio
                    </Text>
                  )}
                </Box>
              )}
            </Box>

              {/* Factura (opcional) */}
              <Box>
                <SelectField
                  id="FacturaId"
                  placeholder="Selecciona una factura (opcional)"
                  label="Factura"
                  mb="0px"
                  options={facturas.map(factura => ({ value: factura.Id.toString(), label: factura.Folio }))}
                  onChange={(value: string) => handleSelectChange('FacturaId', value)}
                  value={formData.FacturaId}
                />
              </Box>

              {/* Costo */}
              <CurrencyField
                id="Precio"
                placeholder="10,000"
                label="Costo"
                required={true}
                value={formData.Precio}
                onChange={handleInputChange}
                isInvalid={formSubmitted && !formData.Precio}
              />

              {/* Depreciación mensual: se calcula sola con Costo x %Rubro / 12 */}
              <CurrencyField
                id="Precio_depreciado"
                placeholder="Se calcula al elegir Costo y Rubro de depreciación"
                label="Depreciación mensual"
                value={formData.Precio_depreciado}
                onChange={handleInputChange}
                isDisabled
              />

              {/* Tipo de adquisición: Capex / OPEX / Arrendamiento */}
              <Box>
                <SelectField
                  id="TipoAdquisicionId"
                  label="Tipo de adquisición"
                  placeholder="Selecciona cómo ingresó el activo"
                  required={true}
                  mb="12px"
                  isInvalid={formSubmitted && !formData.TipoAdquisicionId}
                  options={tiposAdquisicion.map(tipo => ({
                    value: tipo.Id.toString(),
                    label: tipo.Name,
                  }))}
                  value={formData.TipoAdquisicionId}
                  onChange={(value: string) => {
                    const tipoElegido = tiposAdquisicion.find(t => t.Id.toString() === value);
                    const esArrendamiento = tipoElegido?.Name?.toLowerCase() === 'arrendamiento';
                    setFormData(prev => ({
                      ...prev,
                      TipoAdquisicionId: value,
                      TieneArrendamiento: esArrendamiento,
                      ...(esArrendamiento ? {} : { ArrendadoraId: '' }),
                    }));
                  }}
                />
                {formSubmitted && !formData.TipoAdquisicionId && (
                  <Text color="red.500" fontSize="xs" mt="2px" mb="12px">
                    Este campo es obligatorio
                  </Text>
                )}

                <SelectField
                  id="CategoriaDepreciacionId"
                  label={`Rubro de depreciación (tabla ${
                    formData.FechaAdquisicion ? formData.FechaAdquisicion.split('-')[0] : new Date().getFullYear()
                  })`}
                  placeholder={
                    rubrosDepreciacion.length === 0
                      ? 'No hay tabla de depreciación capturada para ese año'
                      : 'Selecciona el rubro contable del activo (opcional)'
                  }
                  mb="0px"
                  isDisabled={rubrosDepreciacion.length === 0}
                  options={rubrosDepreciacion.map(rubro => ({
                    value: rubro.Id.toString(),
                    label: `${rubro.Categoria} (${rubro.Porcentaje}% anual)`,
                  }))}
                  value={formData.CategoriaDepreciacionId}
                  onChange={(value: string) => handleSelectChange('CategoriaDepreciacionId', value)}
                />
                <Text fontSize="xs" color={mutedTextColor} mt="4px">
                  El % se toma de la tabla del año en que se adquirió el activo, no del año en curso.
                </Text>

                {formData.TieneArrendamiento && (
                  <Box mt="12px">
                    <SelectField
                      id="ArrendadoraId"
                      label="Arrendadora"
                      placeholder="Selecciona o escribe para crear una arrendadora"
                      required={true}
                      mb="0px"
                      isInvalid={formSubmitted && !formData.ArrendadoraId}
                      isLoading={isCreatingArrendadora}
                      creatable
                      onCreateOption={handleCreateArrendadora}
                      options={arrendadoras.map(arrendadora => ({
                        value: arrendadora.Id.toString(),
                        label: arrendadora.Name,
                      }))}
                      value={formData.ArrendadoraId}
                      onChange={(value: string) => handleSelectChange('ArrendadoraId', value)}
                    />
                    {formSubmitted && !formData.ArrendadoraId && (
                      <Text color="red.500" fontSize="xs" mt="2px">
                        Este campo es obligatorio
                      </Text>
                    )}
                  </Box>
                )}
              </Box>

              {/* Permitido Salir */}
              <ToggleButton
                id="PermitidoSalir"
                label={`Permitido Salir: ${formData.PermitidoSalir ? '✓ Sí' : '✗ No'}`}
                isChecked={formData.PermitidoSalir}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleToggleChange('PermitidoSalir', e.target.checked)}
              />
            </Stack>
          </SimpleGrid>

          {/* Folio: después de Permitido Salir, en un recuadro más visible */}
          <Box
            p="16px"
            borderRadius="14px"
            border="2px solid"
            borderColor={folioBoxBorder}
            bg={folioBoxBg}
          >
            <Flex align="center" mb="10px">
              <Text fontSize="md" fontWeight="700" color={textColor}>Folio sugerido</Text>
              <Text color="red.400" ml="1">*</Text>
            </Flex>

            <Flex>
              {/* Parte fija */}
              <Input
                value={folioPrefix}
                isReadOnly
                width="auto"
                fontSize="lg"
                fontWeight="bold"
                borderWidth="1px"
                borderRadius="10px"
                borderRightRadius="0"
                borderColor={boxSectionBorder}
                bg={folioPrefixBg}
                color={folioPrefixColor}
              />

              {/* Solo edita los 6 últimos dígitos */}
              <Input
                id="FolioEditable"
                value={folioSuffixInput}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, '');
                  const limited = onlyNumbers.slice(0, 6); // límite 6 números

                  setFolioSuffixInput(limited); // actualiza lo que ves en el input

                  const newFolio =
                    limited === '' ? folioPrefix : `${folioPrefix}${limited}`;

                  setFormData(prev => ({ ...prev, Folio: newFolio }));
                }}
                maxLength={6}
                fontSize="lg"
                fontWeight="bold"
                borderWidth="1px"
                borderRadius="10px"
                borderLeftRadius="0"
                borderLeftWidth="0"
                borderColor={boxSectionBorder}
                bg={folioSuffixBg}
                color={inputTextColor}
                _hover={{ borderColor: inputHoverBorder }}
                _focus={{
                  borderColor: inputFocusBorder,
                  boxShadow: `0 0 0 2px ${inputFocusShadowColor}`,
                }}
              />
            </Flex>

            <Text fontSize="xs" color={folioPrefixColor} mt="8px">
              Se genera con el hotel, línea y sublínea elegidos arriba. Puedes editar los últimos 6 dígitos si lo necesitas.
            </Text>
          </Box>

          {/* Imagenes del Activo */}
          <Text color={textColor} fontSize="2xl" fontWeight="700" mb="10px">
            Imágenes del Activo
          </Text>

          {!imagenFile ? (
            <Box
              border="2px dashed"
              borderColor={formSubmitted ? "red.500" : brand}
              borderRadius="lg"
              p={6}
              textAlign="center"
              cursor="pointer"
              _hover={{ bg: hoverBg }}
            >
              <Flex direction="column" align="center">
                <Icon as={MdOutlineCloudUpload} w="60px" h="60px" color={formSubmitted ? "red.500" : brand} mb={3} />
                <Text fontSize="md" fontWeight="600" color={textColor}>
                  Sube una imagen del activo
                </Text>
                <Text fontSize="sm" color="gray.500" mb={2}>
                  Imagen opcional
                </Text>

                <Button
                  mt={3}
                  colorScheme={formSubmitted ? "red" : "brand"}
                  variant="outline"
                  size="sm"
                  onClick={() => document.getElementById('file-upload')?.click()}
                >
                  Seleccionar archivo
                </Button>

                <Text fontSize="xs" color="gray.500" mt={2}>
                  Formatos: JPG, PNG (Recomendado: 800x600px)
                </Text>
              </Flex>

              <input
                id="file-upload"
                type="file"
                accept="image/*"

                onChange={handleImageUpload}
                style={{ display: 'none' }}
              />
            </Box>
          ) : (
            <Box
              position="relative"
              maxW="300px"
              mt={2}
            >
              <Box
                borderRadius="md"
                overflow="hidden"
                boxShadow="md"
              >
                <img
                  src={URL.createObjectURL(imagenFile)}
                  alt="Vista previa"
                  style={{ width: '100%', height: 'auto' }}
                />
              </Box>
              <Flex justify="space-between" mt={2} align="center">
                <Text fontSize="sm" color="gray.600">
                  {imagenFile.name} ({(imagenFile.size / 1024).toFixed(1)}KB)
                </Text>
                <Button
                  size="xs"
                  colorScheme="red"
                  variant="ghost"
                  onClick={() => setImagenFile(null)}
                >
                  Eliminar
                </Button>
              </Flex>
            </Box>
          )}

          {/*  {formSubmitted && !imagenFile && (
            <Text color="red.500" fontSize="sm" mt={2}>
              La imagen es obligatoria
            </Text>
          )} */}

          <Flex justify="flex-end" align="center" mt="24px" gap="20px">
{!qrGenerado ? (
  <Button
    variant="darkBrand"
    fontSize="sm"
    borderRadius="16px"
    w={{ base: '128px', md: '148px' }}
    h="46px"
    onClick={handleGenerateQR}
    isLoading={isGeneratingQR}
    loadingText="Generando..."
    disabled={isGeneratingQR}
    leftIcon={isGeneratingQR ? undefined : undefined}
    spinner={
      <Icon
        as={FiLoader} // Necesitarás importar FiLoader de react-icons/fi
        className="animate-spin"
        w="16px"
        h="16px"
      />
    }
  >
    Generar QR
  </Button>
) : (
  <Button
    variant="darkBrand"
    fontSize="sm"
    borderRadius="16px"
    w={{ base: '128px', md: '148px' }}
    h="46px"
    onClick={() => {
      // Aquí puedes agregar lógica adicional si necesitas
      navigate('/admin/main/ecommerce/order-list');
    }}
  >
    Volver al listado
  </Button>
)}

            {qrGenerado && (
              <Box id="qrBox" ml="20px" p="10px" border="1px solid #E2E8F0" borderRadius="lg" textAlign="center">
                <Text fontWeight="bold" fontSize="sm" mb={2}>Código QR</Text>
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://inventariosbackend.velasresorts.com/inventarios/check/qr/${sessionStorage.getItem('qrId')}`}
                  alt="Código QR"
                  style={{ borderRadius: '8px' }}
                />
              </Box>
            )}
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
}